var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJyjq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 69",
    className: "design-iconfont",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "98.993048%",
    id: "sso5gw3aec"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AB6F5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#227BF9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "gikzwp28jb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DCFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60A2FE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "15.471211%",
    y1: "14.7209959%",
    x2: "90.6264681%",
    y2: "87.9987595%",
    id: "levo8rhppd"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F2FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2F2FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-44%",
    y: "-37%",
    width: "187.9%",
    height: "173.9%",
    filterUnits: "objectBoundingBox",
    id: "1aq4r289na"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.329116928 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#1aq4r289na)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29,5 C35.3506307,5 41.0997889,7.58913593 45.2614593,11.7744092 C49.4251707,15.9617352 52,21.7466044 52,28.1361163 C52,33.6616494 48.5782888,40.4412816 44.3475291,46.410863 C38.7842583,54.2606113 31.7296255,61 29,61 C26.2703745,61 19.2157417,54.2606113 13.6524709,46.410863 C9.42171119,40.4412816 6,33.6616494 6,28.1361163 C6,21.7466044 8.57482926,15.9617352 12.7385407,11.7744092 C16.9002111,7.58913593 22.6493693,5 29,5 Z",
    stroke: "url(#gikzwp28jb)",
    strokeWidth: 2,
    fill: "url(#sso5gw3aec)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.484405,2.78383271 L19.0345521,0.335454014 C18.8114444,0.111091916 18.5211877,0 18.2330971,0 C17.9428405,0 17.6525838,0.111091916 17.4316422,0.335454014 C16.9875928,0.781999944 16.9875928,1.50300826 17.4316422,1.94955421 L19.0193894,3.55058476 L17.8453662,4.78130893 C17.4619675,5.17775459 17.4619675,5.81381027 17.8453662,6.20807764 C18.0316503,6.40847875 18.2829173,6.50650102 18.5320182,6.50650102 L18.5428486,6.50650102 L19.8706646,6.50432275 L19.8706646,16.9491411 C19.8706646,17.3368737 19.558747,17.6614363 19.1753482,17.6614363 L19.1623517,17.6614363 C18.7854512,17.6549015 18.482198,17.3455867 18.482198,16.964389 L18.482198,10.4557097 C18.482198,8.78715271 17.1370533,7.43662354 15.479991,7.43662352 C15.0965923,7.43662352 14.7868408,7.12295222 14.7868407,6.73957621 L14.7868407,1.86024502 C14.7868407,0.834278501 13.9593926,0.00217826773 12.9391621,0.00217826773 L3.23505864,0.00217826773 C2.21482814,0.00217826773 1.38738003,0.834278501 1.38738003,1.86024502 L1.38738003,19.7721827 C1.38738003,19.8898094 1.29207188,19.9878317 1.17510276,19.9878317 C0.86535124,19.9878317 0.579426765,20.109815 0.367149503,20.3102161 C0.15270613,20.5062606 0.0162421927,20.7850796 0.00107952338,21.0965726 C-0.0270797041,21.7609458 0.499281261,22.3076923 1.15560789,22.3076923 L15.0034502,22.3076923 C15.6381159,22.3076923 16.1688091,21.7979765 16.1753073,21.1597425 C16.1818056,20.5106172 15.664109,19.9856534 15.020779,19.9856534 C14.8908133,19.9856534 14.7868408,19.8810964 14.7868407,19.7504 L14.7868407,10.4600662 C14.7868407,10.0745119 15.0965923,9.76301894 15.479991,9.76301894 C15.6706073,9.76301894 15.846061,9.84143675 15.9716944,9.96777659 C16.0973279,10.0941164 16.1753073,10.2683782 16.1753073,10.4622445 L16.1753073,16.9665673 C16.1753073,18.6351243 17.520452,19.9878317 19.1775143,19.9878317 C20.8367427,19.9878317 22.1818874,18.632946 22.1818874,16.9665673 L22.1818874,4.45238972 C22.1818874,3.79672958 21.9132917,3.20641763 21.484405,2.78383271 Z M3.69698124,3.30879646 C3.69698124,2.60034044 4.36012726,2.02797203 5.17577375,2.02797203 L11.4606419,2.02797203 C12.2762883,2.02797203 12.9394343,2.60034044 12.9394343,3.30879646 L12.9394343,6.83106366 C12.9394343,7.53751839 12.2762883,8.11188811 11.4606419,8.11188811 L5.17577375,8.11188811 C4.36012726,8.11188811 3.69698124,7.53751839 3.69698124,6.83106366 L3.69698124,3.30879646 Z M20.3333968,6.08028173 L19.0543606,6.08391608 L18.4849062,6.08391608 L19.2660426,5.09173622 L20.0829562,4.05594406 C20.2469352,4.32852096 20.3333968,4.64834448 20.3333968,4.98633982 L20.3333968,6.08028173 L20.3333968,6.08028173 Z",
    transform: "translate(19.018151 16.667948)",
    fill: "url(#levo8rhppd)",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJyjq);
export default __webpack_public_path__ + "static/media/jyjq.c77256c195fd2d247bb12459f5985dd7.svg";
export { ForwardRef as ReactComponent };